app.mediator.registerModule(MODULE_NAME__NEWSLETTER_FLASH_CTA, function(app) {

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$rootElem = $('.mod-newsletter-flash-cta');
            if (!this.$rootElem.length) return;

            scope.addDomListeners();
		},

        addDomListeners: function () {
            var scope = this;
            this.$rootElem.find('.newsletter-btn').click(function () {
                app.mediator.notify(EVENT_NAME__NEWSLETTER_FLASH_CTA__BUTTON_CLICKED, {
                    barWasStickyWhenButtonWasClicked: scope.isSticky()
                });
            });
        },

		//==========================================================xdiv2====
		// Module
		//===================================================================

        isSticky: function () {
            var $stickyWrapper = this.$rootElem.closest('.mod-sticky-follower-top');
            if ($stickyWrapper.length) {
                return $stickyWrapper.hasClass('navbar-fixed-top');
            }
            return false;
        }
	};
});